export const VITE_OTP_GATEWAY_URL = import.meta.env.VITE_OTP_GATEWAY_URL;
export const VITE_ZEM_GATEWAY_URL = import.meta.env.VITE_ZEM_GATEWAY_URL;

// Email typos
export const emailTypos: Record<string, string> = {
	// GMAIL
	"gamil.com": "gmail.com",
	"gmal.com": "gmail.com",
	"gmaill.com": "gmail.com",
	"gmial.com": "gmail.com",
	"gmaii.com": "gmail.com",
	"gamil.com.au": "gmail.com.au",
	"gmail.con": "gmail.com",
	"gmail.con.au": "gmail.com.au",
	"gamail.com": "gmail.com",

	// OUTLOOK
	"outlook.con": "outlook.com",
	"outlok.com": "outlook.com",
	"outllok.com": "outlook.com",
	"outlook.con.au": "outlook.com.au",

	// YAHOO
	"yaho.com": "yahoo.com",
	"yaboo.com.au": "yahoo.com.au",
	"yahoo.con.au": "yahoo.com.au",
	"yaho.com.au": "yahoo.com.au",
	"yahoo.con": "yahoo.com",
	"yhoo.com": "yahoo.com",

	// HOTMAIL
	"htmail.com": "hotmail.com",
	"hotmail.con": "hotmail.com",
	"hotmial.com": "hotmail.com",
	"hotmail.con.au": "hotmail.com.au",

	// ICLOUD / BIGPOND
	"icloud.con": "icloud.com",
	"iclou.com": "icloud.com",
	"bigpond.con": "bigpond.com",
	"bigpond.com.au": "bigpond.com",
	"bigpond.con.au": "bigpond.com",
};

// Initialised loan types
export const LOAN_TYPE_UNSECURED = "Unsecured Business Loan";

// The loan type the form submits as. Change this one constant to switch it.
export const LOAN_TYPE = LOAN_TYPE_UNSECURED;

export const stateOption = [
	{
		option: "QLD",
		value: "QLD",
	},
	{
		option: "NSW",
		value: "NSW",
	},
	{
		option: "SA",
		value: "SA",
	},
	{
		option: "NT",
		value: "NT",
	},
	{
		option: "WA",
		value: "WA",
	},
	{
		option: "TAS",
		value: "TAS",
	},
	{
		option: "ACT",
		value: "ACT",
	},
	{
		option: "VIC",
		value: "VIC",
	},
];
// Loan Type IDs in Fintelligence
export const loan_type = [
	{
		option: "Unsecured Business Loan",
		id: 8, // loanTypeID
		value: "Unsecured Business Loan",
	},
];

// whether the loan is backed by property
export const property_backed = [
	{
		option: "Yes",
		value: "Yes",
	},
	{
		option: "No",
		value: "No",
	},
];

export const abn_age = [
	{
		option: "Less than 6 months",
		value: "Less than 6 months",
	},
	{
		option: "More than 6 months",
		value: "Greater than 6 months",
	},
];

export const ownership_time = [
	{
		option: "Yes",
		value: "Greater than 6 months",
	},
	{
		option: "No",
		value: "Less than 6 months",
	},
];

// Business Loan
export const LOAN_PURPOSE_BUSINESS_TERM_ADVANCE = "Business Term Advance";
export const LOAN_PURPOSE_MERCHANT_CASH_ADVANCE = "Merchant Cash Advance";
export const LOAN_PURPOSE_UNSURE = "Unsure? We Can Assist";

// Asset Type IDs in Fintelligence
export const business_loan_purpose = [
	{
		option: "Business Term Advance",
		id: 5,
		value: "Business Term Advance",
	},
	{
		option: "Merchant Cash Advance",
		id: 5,
		value: "Merchant Cash Advance",
	},
	{
		option: "Unsure? We Can Assist",
		id: 5,
		value: "Unsure? We Can Assist",
	},
];

const businessLoanFields: Record<string, any[]> = {
	loanPurpose: [...business_loan_purpose],
	propertyBacked: [...property_backed],
	abnAge: [...abn_age],
	ownershipTime: [...ownership_time],
};

export const loanFieldsMap: Record<string, Record<string, any[]>> = {
	[LOAN_TYPE_UNSECURED]: businessLoanFields,
};

export const stepProcessMap: Record<string, Record<string, any>> = {
	// Default Steps for all Loan Types except Mortgage and Personal Loan
	Default: [
		{
			id: 0,
			name: "Personal Details",
		},
		{
			id: 1,
			name: "Verification",
		},
		{
			id: 2,
			name: "Living Details",
		},
		{
			id: 3,
			name: "Additional Details",
		},
		{
			id: 4,
			name: "Completed",
		},
	],
};

// App theme settings
export const appSettingsConfig: Record<string, Record<string, string>> = {
	"Jade Finance": {
		themeColor: "#19cc76",
		hoverColor: "#16ac6b",
		themeHeaderTxt: "#142f48",
		bulletBG: "#bbf7d0",
	},
};
